var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.useDefaultDisplay)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.notFoundDisplay)}}):_c('div',{staticClass:"notFound__Container"},[_c('div',{staticClass:"notFound__ContainerContent",domProps:{"innerHTML":_vm._s(_vm.notFoundDisplay)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }